/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Expressive modal size.
 */
export enum EXPRESSIVE_MODAL_SIZE {
  /**
   * Regular size.
   */
  REGULAR = '',

  /**
   * One that takes full width.
   */
  FULL_WIDTH = 'full-width',
}

/**
 * Expressive modal mode.
 */
export enum EXPRESSIVE_MODAL_MODE {
  /**
   * Default.
   */
  DEFAULT = '',

  /**
   * Lightbox.
   */
  LIGHTBOX = 'lightbox',
}
